import { startOfWeek, endOfWeek, endOfMonth, eachDayOfInterval } from 'date-fns'

export const calendarDates = (date) => {
    const start = startOfWeek(date)
    const end = endOfWeek(endOfMonth(date))
    return eachDayOfInterval({ start, end })
}

export const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const weekdays = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];